<template>
  <div class="booking-requested-modal">
    <div class="booking-requested">
      <div
        data-w-id="a7408e60-5da6-2958-c9c2-278461533a10"
        class="link-block-5 w-inline-block"
        @click="cancel"
      >
        <img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt="" />
      </div>
      <div class="div-block-52">
        <h1 class="modal-heading">Booking requested!</h1>
      </div>
      <p class="paragraph-7">
        We sent a booking request to
        <strong>{{ singleProfessional.customerName }}</strong
        >. If they accept, you will receive a notification
      </p>
      <div class="div-block-85-copy">
        <div class="div-block-86">
          <img
            :src="
              singleProfessional.customerDisplayPicture ||
                require('@/assets/timeslot-images/profileImg.svg')
            "
            loading="lazy"
            alt=""
            class="prof-image"
          /><img
            src="@/assets/timeslot-images/checkmark.svg"
            loading="lazy"
            alt=""
            class="image-18"
          />
        </div>
        <div class="text-block-71">
          Consultation with
          <a href="#" class="link-11">{{ singleProfessional.customerName }}</a>
        </div>
        <div class="div-block-87">
          <div class="div-block-88">
            <img
              src="@/assets/timeslot-images/calendar1.svg"
              loading="lazy"
              alt=""
              class="image-19"
            />
            <div class="text-block-69">
              {{ formatDate(new Date(selectedDate)) }}
            </div>
          </div>
          <div class="div-block-88">
            <img
              src="@/assets/timeslot-images/clock1.svg"
              loading="lazy"
              alt=""
              class="image-19"
            />
            <div class="text-block-70">
              {{
                formatHours(new Date(selectedSlot.availableTimeStartTime))
              }}:{{
                formatMinutes(new Date(selectedSlot.availableTimeStartTime))
              }}
              -
              {{ formatHours(new Date(selectedSlot.availableTimeEndTime)) }}:{{
                formatMinutes(new Date(selectedSlot.availableTimeEndTime))
              }}
              {{ formatTime(new Date(selectedSlot.availableTimeEndTime)) }}

              ({{ customerInfo.customerTimezone }})
            </div>
          </div>
        </div>
      </div>
      <div @click="goToBooking" class="button-15 w-button">
        Check booking status
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";

export default {
  name: "BookingRequestedModal",
  props: {
    cancel: Function,
    goToBooking: Function
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalInfo: state => state.professional.professionalInfo,
      singleProfessional: state => state.professional.singleProfessional,
      selectedDate: state => state.availability.selectedDate,
      selectedSlot: state => state.availability.selectedSlot,
      customerInfo: state => state.customer.customerInfo
    })
  },
  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    }
  }
};
</script>

<style scoped>
.prof-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
</style>
